import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { ProjectDeviceModel } from "app/models/projectDevice.model";
import { ProjectDeviceService } from "app/services/api/projectDevice.service";
import { ContextService } from "app/services/context.service";
import { ToastrService } from "ngx-toastr";
import { DeviceModel } from "../../../models/device.model";
import { DeviceService } from "../../../services/api/device.service";
import { MatTableDataSource } from "@angular/material/table";
import { locale as catalan } from "../i18n/ca";
import { locale as english } from "../i18n/en";
import { locale as spanish } from "../i18n/es";
import { Cloudinary } from "@cloudinary/url-gen";
import { CloudinaryImage } from "@cloudinary/url-gen/assets/CloudinaryImage";
import { fill, limitFit } from "@cloudinary/url-gen/actions/resize";

@Component({
    selector: "devices",
    templateUrl: "./devices.component.html",
    styleUrls: ["./devices.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false,
})
export class DevicesComponent implements OnInit {
    private readonly cloudinary = new Cloudinary({ cloud: { cloudName: "emmadb" } });
    private readonly cloudinaryImageCache = new Map<string, CloudinaryImage>();

    projectDevices: ProjectDeviceModel[] = [];
    devices: DeviceModel[] = [];
    dataSource = new MatTableDataSource<ProjectDeviceModel>([]);
    displayedColumns = ["image", "picture", "name", "active", "last_data", "address"];

    constructor(
        private projectDeviceService: ProjectDeviceService,
        private deviceService: DeviceService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private contextService: ContextService,
        private toastr: ToastrService,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, spanish, catalan);
    }

    public ngOnInit(): void {
        this.loadData();
    }

    private loadData(): void {
        const currentProject = this.contextService.currentProject;
        this.projectDeviceService.getAll(currentProject).subscribe(
            (devices: ProjectDeviceModel[]) => {
                setTimeout(() => {
                    this.projectDevices = devices;
                    this.dataSource.data = devices || [];
                }, 0);
            },
            (error) => {
                console.log(error);
                this.toastr.error("Error: " + error.message);
            },
        );

        // this.deviceService.getAll().subscribe(
        //   (devices: DeviceModel[]) => {
        //       this.devices = devices;
        //   },
        //   (error) => {
        //       console.log(error);
        //       this.toastr.error('Error: ' + error.message);
        //   },
        // );
    }

    public getLastDate(projectDevice: ProjectDeviceModel): Date {
        return ProjectDeviceModel.lastDataTime(projectDevice.lastData);
    }

    public getDevicePicture(projectDevice: ProjectDeviceModel): string {
        if (projectDevice.picture) {
            return projectDevice.picture;
        }

        if (this.devices) {
            const device = this.devices.find((d) => projectDevice.baseDevice === d.id);
            return device ? device.picture : null;
        }

        return null;
    }

    public getCloudinaryImage(
        publicId: string | null | undefined,
        width: number | null = null,
        height: number | null = null,
        crop: "fill" | "limit" = "limit",
    ): CloudinaryImage | null {
        const id = (publicId || "").trim();
        if (!id || id.startsWith("http://") || id.startsWith("https://") || id.startsWith("data:")) {
            return null;
        }

        const key = `${id}|${width ?? ""}|${height ?? ""}|${crop}`;
        const cached = this.cloudinaryImageCache.get(key);
        if (cached) {
            return cached;
        }

        const image = this.cloudinary.image(id).format("auto").quality("auto");

        if (width !== null || height !== null) {
            const resizeAction = crop === "fill" ? fill() : limitFit();
            if (width !== null) {
                resizeAction.width(width);
            }
            if (height !== null) {
                resizeAction.height(height);
            }
            image.resize(resizeAction);
        }

        this.cloudinaryImageCache.set(key, image);
        return image;
    }
}
